var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-descriptions',{attrs:{"title":"基本信息"}},[_c('el-descriptions-item',{attrs:{"label":"公司全称"}},[_vm._v(_vm._s(_vm.info.departmentName))]),_c('el-descriptions-item',{attrs:{"label":"公司代码"}},[_vm._v(_vm._s(_vm.info.departmentDesc))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }